/* eslint-disable */
import axios from "axios";
import eventEmitter from "./test";
import { postMethod } from "../../utils/helpers/functions/textUtils";
import { localGetAuthUUID, localGetToken } from "../../utils/localStorage";
const addHeaders = async (url, options, dataHeaders, isAuth, module) => {
  let headers = {
    "Content-Type": "application/json",
    responseType: "blob",
    "x-auth-uuid": "",
  };
  let token = localGetToken();

  let uuid = localGetAuthUUID();
  if (isAuth && token) {
    headers.Authorization = "Bearer " + token;
  }
  if (isAuth && uuid) {
    headers["x-auth-uuid"] = uuid;
  }
  if (dataHeaders) {
    headers = { ...headers, ...dataHeaders };
  }
  if (module) {
    if (module === 1) {
      headers = { ...headers, module: "Client" };
    }
    if (module === 2) {
      headers = { ...headers, module: "FormAnswer" };
    }
  }
  return axios({ url: `${url}`, headers: headers, ...options });
};

const apiDownloadBlob = (method, isAuth) => (url, payload, token) => {
  return new Promise((resolve, reject) => {
    addHeaders(
      url,
      {
        method,
        responseType: "blob",
        data: method !== "GET" ? payload : postMethod(payload),
        params: method === "GET" ? payload || "" : "",
      },
      undefined,
      isAuth || false
    )
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        let catchError = handleError({
          ...err.response,
          url: url,
        });
        reject(catchError);
      });
  });
};

const apiWithPayload =
  (method, isAuth) =>
  (url, payload, token, isBlob = false) => {
    return new Promise((resolve, reject) => {
      addHeaders(
        url,
        {
          method,
          responseType: isBlob ? "blob" : undefined,
          data: method !== "GET" ? payload : postMethod(payload),
          params: method === "GET" ? payload || "" : "",

          onDownloadProgress: (progressEvent) => {
            eventEmitter.emit(
              "UPLOAD_PROGRESS",
              Math.floor(100 * (progressEvent.loaded / progressEvent.total))
            );
          },
        },
        undefined,
        isAuth || false
      )
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          let catchError = handleError({
            ...err.response,
            url: url,
          });
          reject(catchError);
        });
    });
  };

const apiWithFormData = (method, isAuth, module) => async (url, formData) => {
  let _data = new FormData();
  Object.entries(formData).forEach(([key, value]) => {
    console.log(key, value);
    _data.append(key, value);
  });

  return new Promise((resolve, reject) => {
    addHeaders(
      url,
      {
        method,
        data: _data,
      },
      {
        // 'Accept': 'multipart/form-data',
        "Content-type": "multipart/form-data",
        // 'accept-encoding': 'gzip',
      },
      isAuth || false,
      module
    )
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        let catchError = handleError(err.response);
        reject(catchError);
      });
  });
};

const handleError = (err) => {
  let resultError;
  if (err?.data) {
    resultError = {
      message: err?.data?.message,
      statusCode: err?.data?.statusCode,
    };
  } else {
    resultError = {
      message: "Lỗi hệ thống !",
      statusCode: 500,
    };
  }
  //token exprired
  // if (err?.status === 408)
  // configureStore().dispatch(putSignIn(false));
  return resultError;
};

export const api = {
  get: apiWithPayload("GET", true),
  getDowload: apiDownloadBlob("GET", true),
  getNoAuth: apiWithPayload("GET", false),
  delete: apiWithPayload("DELETE", true),
  post: apiWithPayload("POST", true),
  postLogin: apiWithPayload("POST", false),

  patch: apiWithPayload("PATCH", true),
  postDownload: apiDownloadBlob("POST", true),
  put: apiWithPayload("PUT", true),
  postMultipart: apiWithFormData("POST", true, false),
  postMultipartModule: apiWithFormData("POST", true, true),
  postMultipartClient: apiWithFormData("POST", true, 1),
  postMultipartFormAnswer: apiWithFormData("POST", true, 2),
  // putMultipart: apiWithFormData('PUT')
};
